export default __webpack_public_path__ + "locales/uk-UA/Common.json?hash=99478a7ad9dc12f878976d669f90e1b6";